setTimeout(function () {
    if (document.querySelector(".mobile-swiper")) {
    const swiper = new Swiper(".mobile-swiper", {
        autoplay: {
            delay: 3500,
        },
        effect: "fade",
        speed: 2500,
        fadeEffect: {
            crossFade: true,
        },
        // Optional parameters
        direction: "horizontal",
        loop: true,
        grabCursor: true,

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });
    }

    if (document.querySelector(".pc-swiper")) {
    const swiper2 = new Swiper(".pc-swiper", {
        autoplay: {
            delay: 3500,
        },
        effect: "fade",
        speed: 2500,
        fadeEffect: {
            crossFade: true,
        },
        // Optional parameters
        direction: "horizontal",
        loop: true,
        grabCursor: true,

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });
    }

    const swiper3 = new Swiper(".swiper", {
        autoplay: {
            delay: 2500,
        },
        // Optional parameters
        direction: "horizontal",
        loop: true,
        grabCursor: true,

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });

    const swiper4 = new Swiper(".limited-swiper-pc", {
        autoplay: {
            delay: 3500,
        },
        effect: "fade",
        speed: 2500,
        fadeEffect: {
            crossFade: true,
        },
        // Optional parameters
        direction: "horizontal",
        loop: true,
        grabCursor: true,
    });

    const swiper5 = new Swiper(".limited-swiper-sp", {
        autoplay: {
            delay: 3500,
        },
        effect: "fade",
        speed: 2500,
        fadeEffect: {
            crossFade: true,
        },
        // Optional parameters
        direction: "horizontal",
        loop: true,
        grabCursor: true,
    });
}, 4500);
